/**
 * Public Auth Pages Analytics Entrypoint
 *
 * Vite entrypoint loaded by `authentication.html.erb`, the layout shared by
 * every Devise page (login, register, password reset, ...). Marketing links
 * land here, so this is where their UTMs are first seen: `initPostHog` stashes
 * them and hands them to PostHog once analytics consent is granted.
 *
 * Must load after `consent.ts`, which initializes the consent core that
 * PostHog capture is gated on.
 *
 * The GTM `app_page_view` push (with the stashed UTMs) is not consent-gated:
 * Consent Mode decides which tags fire on it.
 */

import { capturePublicPageview, initPostHog } from "../app/utils/posthog";
import { pushAppPageView, stashLandingUtm } from "../app/analytics/dataLayer";

initPostHog();
capturePublicPageview();
stashLandingUtm();
pushAppPageView();
